// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Footnote: MarkdocTagRegistration = {
  tag: 'footnote',
  component: 'Footnote',
};
